import i18next from 'i18next';
import * as Yup from 'yup';
import {
  createValidationSchema,
  commonValidationSchemas,
} from 'infrastructure/functions/validation-schemas';

export interface IClinicFormValue {
  guid: string;
  name: string;
  state: string;
  patientCount: number;
}

export interface IMemberFormValue {
  loginGuid: string;
  name: string;
  role: string;
  priority: 'primary' | 'secondary' | 'tertiary';
}

export const createPodValidationSchema = () =>
  createValidationSchema({
    podName: commonValidationSchemas
      .string({
        required: { message: i18next.t('labels.podNameRequired') },
        fieldName: 'Pod name',
      })
      .max(255),
    isActive: commonValidationSchemas.boolean().default(true),
    podType: commonValidationSchemas
      .string({ required: true })
      .oneOf(['RPM', 'CCM']),
    states: Yup.array()
      .of(Yup.string().defined())
      .default([])
      .when('podType', {
        is: 'RPM',
        then: (schema: Yup.ArraySchema<Yup.StringSchema>) =>
          schema.min(1, i18next.t('labels.selectAtLeastOneStateForRpm')),
        otherwise: (schema: Yup.ArraySchema<Yup.StringSchema>) =>
          schema.default([]),
      }),
    clinicGuids: Yup.array()
      .min(1, i18next.t('labels.selectAtLeastOneClinic'))
      .default([]),
    members: Yup.array()
      .min(1, i18next.t('labels.selectAtLeastOneMember'))
      .default([]),
  });

export interface ICreatePodFormValues {
  podName: string;
  isActive: boolean;
  podType: 'RPM' | 'CCM';
  states: string[];
  clinicGuids: IClinicFormValue[];
  members: IMemberFormValue[];
}
